import { client } from "api";

export type GetThumbnailRequest = string;
export type GetThumbnailResponse = Blob;

export const getThumbnail = (id: GetThumbnailRequest) =>
  client
    .get<GetThumbnailResponse>(`/bin/thumb/${id}`, {
      responseType: "blob",
    })
    .then((res) => res.data);
